<template>
    <ModalComponent
        :name="'borrar-patrocinador-' + patrocinador.id"
        :title="'¿Seguro que quieres borrar el patrocinador: ' + patrocinador.nombre + '?'"
        v-on:close="() => close(false)"
    >
        <div class="row">
            <div class="col-12">
                <ul class="list-group list-group-unbordered mb-3">
                    <li class="list-group-item">
                        <b>Patrocinador:</b> {{ patrocinador.nombre }}
                    </li>
                </ul>
            </div>
            <div class="col-12 text-center">
                <h1 class="font-weight-bold">¿BORRAR PATROCINADOR?</h1>
            </div>
            <div class="col-12 text-center">
                <Button id="boton_borrar" type="button" name="button" @click="borrarpatrocinador">SI, BORRAR</Button>
            </div>
        </div>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['patrocinador'],
        data() {
            return {
                loading: false
            }
        },
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-patrocinador-' + this.patrocinador.id, borrado);
            },
            borrarpatrocinador() {
                this.loading = true;

                const params = {
                    filters : {},
                    patrocinador_id: this.patrocinador.id,
                    lista_id: this.$store.getters.getListaId,
                }

                this.$store.dispatch(this.config.getVuexAlias('back.patrocinadores.borrar'), params).then(res => {
                    this.expand = [];
                    this.$toast.success(res.data.message);
                    this.close(true);
                }).finally(() => this.loading = false);
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
